export const SectionLabel = ({ index, text, className = "" }) => (
    <div className={`flex items-center gap-4 ${className}`} data-testid={`section-label-${index}`}>
        <span className="font-sans text-[11px] font-semibold tracking-[0.35em] text-scarlet">
            {index}
        </span>
        <span className="h-px w-10 bg-crimson/60" aria-hidden="true" />
        <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.35em] text-ash">
            {text}
        </span>
    </div>
);
